import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import MasterApplyControl from './MasterApplyControl.vue';
import MemberApplyControl from './MemberApplyControl.vue';
import { useBasicStore } from '../../../../stores/basic';
import { ETUIRoomRole } from '../../../tui-room-core';


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const basicStore = useBasicStore();

const showMasterControl = computed(() => Boolean(basicStore.role) && basicStore.role === ETUIRoomRole.MASTER);

const showMemberControl = computed(() => Boolean(basicStore.role) && basicStore.role !== ETUIRoomRole.MASTER);


return { __sfc: true,basicStore, showMasterControl, showMemberControl, MasterApplyControl, MemberApplyControl }
}

})